
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useIsSystemAdmin = () => {
  return useQuery({
    queryKey: ['user-role-system-admin'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;
      
      try {
        // Check if user has system_admin role
        const { data: roleData, error: roleError } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .eq('role', 'system_admin')
          .single();
        
        const hasSystemAdminRole = !roleError && roleData !== null;
        
        if (hasSystemAdminRole) {
          console.log('User has system_admin role');
          return true;
        }

        console.log('User does not have system_admin role');
        return false;
      } catch (error) {
        console.log('Error checking system admin role:', error);
        return false;
      }
    }
  });
};
